import * as $ from 'jquery'
import {IVTError} from '../lib/error-types'
import {CallJs} from "../lib/types"

export function onPendingStatusUpdated() {
	var membershipForm = $('form[name=membershipForm]')
	var pendingStatusSerial = membershipForm.find('[name=pendingStatusSerial]')
	var selectedOption = pendingStatusSerial.find(':selected')

	pendingStatusSerial.css('backgroundColor',selectedOption[0].style.backgroundColor || "")
}

var statusChanged:boolean = false
export const getStatusChanged = () => statusChanged

var newStatus:string = ''
export const getNewStatus = () => newStatus

export function statusSerialOnChange() {
	var membershipForm = $('form[name=membershipForm]')
	var statusSerial = membershipForm.find('[name=statusSerial]')
	var selectedOption = statusSerial.find(':selected')
	
	statusSerial.css('backgroundColor',selectedOption[0].style.backgroundColor || "")
	newStatus = selectedOption.text()
	statusChanged = true
}

export function preReqMaskedStatusSerialOnChange() {
	var membershipForm = $('form[name=membershipForm]')
	var statusSerial = membershipForm.find('[name=preReqMaskedStatusSerial]')
	var selectedOption = statusSerial.find(':selected')

	statusSerial.css('backgroundColor',selectedOption[0].style.backgroundColor || "")
}

var oldExpiryValue:Date
export function updateExpiryCheckbox(checkboxId:string) {
	var expiryDate = $('#expiryDateFormatted')
	if ($(`#${checkboxId}:checked`).length > 0)
	{
		if ( expiryDate.datepicker('getDate') != null )
			oldExpiryValue = expiryDate.datepicker( 'getDate' )

		expiryDate.datepicker('setDate', null)
		expiryDate.datepicker('disable')
	}
	else
	{
		if (oldExpiryValue)
			expiryDate.datepicker( 'setDate', oldExpiryValue )

		expiryDate.datepicker('enable');
	}
}

var oldApprovedValue:{[key:string]:Date} = {}
var currentStatusSerial:{[key:string]:string} = {}
export function updateApprovedCheckbox(membership:Membership, approvalType:ApprovalType, activeStatusSerial:number) {
	var approvalTabField = ApprovalTabField.createFromApprovalType(membership,approvalType)
	var name = approvalTabField.name()
	var statusTarget = approvalTabField.statusTarget()
	var date = $(`#${name}DateFormatted`)
	var status = $(`select[name=${statusTarget}]`)

	if($(`#${name}Checkbox:checked`).length > 0)
	{
		date.datepicker('setDate', oldApprovedValue[statusTarget])
		date.datepicker('enable')

		status.val(`${activeStatusSerial}`)
		approvalTabField.updateStatus()
	}
	else
	{
		if(date.datepicker('getDate') != null)
			oldApprovedValue[statusTarget] = date.datepicker('getDate')

		date.datepicker('setDate', null)
		date.datepicker('disable')
		
		status.val(currentStatusSerial[statusTarget])
		approvalTabField.updateStatus()
	}
}

type InitaliseApprovalCheckboxCallJsParams = {
	membership: Membership
	approvalType: ApprovalType
}

export const initaliseApprovalCheckbox:CallJs<InitaliseApprovalCheckboxCallJsParams> = (replace, params) => {
	var approvalTabField = ApprovalTabField.createFromApprovalType(params.membership,params.approvalType)
	var name = approvalTabField.name()
	var statusTarget = approvalTabField.statusTarget()
	oldApprovedValue[statusTarget] = new Date()
	currentStatusSerial[statusTarget] = $(`select[name=${statusTarget}]`).find(':selected').val()
}

type Membership = {
	type: MembershipType
	preReqMaskedStatus: number
	hasStatusAfterRenewal: boolean
}

type MembershipType = {
	applyStatusAfterRenewal: boolean
}

type ApprovalType = 'signupApproval' | 'renewalApproval' | 'futureRenewalApproval'
type ApprovalName = 'approved'|'approvedAfterRenewal'

abstract class ApprovalTabField {
	constructor(public membership:Membership) {}

	static createFromApprovalType(membership:Membership, approvalType:ApprovalType):ApprovalTabField {
		switch(approvalType) {
			case 'signupApproval':
				return new SignupApprovalTabField(membership)
			case 'renewalApproval' :
				return new CurrentRenewalApprovalTabField(membership)
			case 'futureRenewalApproval':
				return new FutureRenewalApprovalTabField(membership)
			default:
				throw new IVTError(`Unknown type: '${approvalType}'`)
		}
	}
	
	abstract name():ApprovalName
	abstract statusTarget():string
	abstract updateStatus():void
}

class SignupApprovalTabField extends ApprovalTabField {
	name():ApprovalName { return 'approved' }
	statusTarget() { return this.membership.preReqMaskedStatus == 0 ? 'statusSerial' : 'preReqMaskedStatusSerial' }
	updateStatus() { return this.membership.preReqMaskedStatus == 0 ? statusSerialOnChange() : preReqMaskedStatusSerialOnChange() }
}

class CurrentRenewalApprovalTabField extends ApprovalTabField {
	name():ApprovalName { return 'approvedAfterRenewal' }
	statusTarget() { return this.membership.preReqMaskedStatus == 0 ? 'statusSerial' : 'preReqMaskedStatusSerial' }
	updateStatus() { return this.membership.preReqMaskedStatus == 0 ? statusSerialOnChange() : preReqMaskedStatusSerialOnChange() }
}

class FutureRenewalApprovalTabField extends ApprovalTabField {
	name():ApprovalName { return 'approvedAfterRenewal' }
	statusTarget() {
		return this.membership.type.applyStatusAfterRenewal && this.membership.hasStatusAfterRenewal
			? 'pendingStatusSerial'
			: (this.membership.preReqMaskedStatus == 0 ? 'statusSerial' : 'preReqMaskedStatusSerial')
	}
	updateStatus() {
		this.membership.type.applyStatusAfterRenewal && this.membership.hasStatusAfterRenewal
			? onPendingStatusUpdated()
			: (this.membership.preReqMaskedStatus == 0 ? statusSerialOnChange : preReqMaskedStatusSerialOnChange() )
	}
}



// WEBPACK FOOTER //
// ./src/membership3/membership-details.ts